import { LoginOption } from '../../../constant/sso';
import { ConfigurationSettings } from '../../../models/configuration-settings';
import { EVENTS } from 'analytics/events';
import { trackEvent } from 'analytics/tracker';

const safeJsonParse = async (response: Response) => {
  try {
    if (!response?.text) {
      console.error('Invalid response object');
      return { error: 'Invalid response object' };
    }

    const text = await response.text();

    if (!text || text.trim() === '') {
      console.error('Empty response received');
      return { error: 'Empty response received' };
    }

    try {
      return JSON.parse(text);
    } catch (parseError) {
      console.error('JSON parse error:', parseError);
      console.error('Failed to parse JSON response:', text);
      return {
        error: 'Invalid JSON response',
        rawResponse: text,
      };
    }
  } catch (error) {
    console.error('Response handling error:', error);
    return { error: 'Failed to process response' };
  }
};

export class SsoService {
  async getSocialLoginEndpoint(payload: any, config: ConfigurationSettings) {
    try {
      const baseUrl = `https://${config.paths.baseUrl}`;
      const rawResponse = await fetch(
        `${baseUrl}${config.paths.authentication.getSocialLogInEndPoint.replace(':clientId', payload.clientId).replace(':redirectUri', payload.redirectUri)}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'x-blocks-key': config.blocksKey,
          },
        }
      );

      if (!rawResponse.ok) {
        console.error('API responded with error status:', rawResponse.status);
        trackEvent(EVENTS.ERROR(new Error("Getting Social Login Endpoint"), {
          endpoint: config.paths.authentication.getSocialLogInEndPoint,
          method: 'POST',
          status: rawResponse.status
        }))
        return {
          error: `API error: ${rawResponse.status}`,
          status: rawResponse.status,
        };
      }

      return await safeJsonParse(rawResponse);
    } catch (error) {
      console.error('Request failed:', error);
      return { error: 'Failed to make request' };
    }
  }
}

export const getLoginOption = async (
  config: ConfigurationSettings
): Promise<LoginOption | null> => {
  try {
    const baseUrl = `https://${config.paths.baseUrl}`;
    const response = await fetch(`${baseUrl}${config.paths.authentication.getLoginOptions}`, {
      method: 'GET',
      headers: { 'X-Blocks-Key': config.blocksKey },
    });

    if(!response.ok) {
      trackEvent(EVENTS.ERROR(new Error("Getting Login Options"), {
        endpoint: config.paths.authentication.getLoginOptions,
        method: 'GET',
        status: response.status
      }))
    }

    // Just parse the response once, no need for JSON.parse
    return await response.json();
  } catch (error) {
    console.error('Error fetching login options:', error);
    return null;
  }
};
